<template>
  <div
    v-if="$parent.participant"
    id="participants-container"
    class="position-relative participantsContainer">
    <div class="fs14 d-none d-md-block py-3"><b>{{ $t('MEETING.PARTICIPANTS') }}</b>
      <b-badge>{{ canSeeWaitingList ? participants.length: inMeeting.length }}</b-badge>
    </div>
    <div class="mobileHeader align-items-center shadow d-flex  flex-row justify-content-between p-4">
      <span class="fs14 ml-auto"><b>{{ $t('MEETING.PARTICIPANTS') }}</b></span>
      <close-icon
        class="ml-auto"
        @click="toggleTab()"/>
    </div>
    <perfect-scrollbar>
      <!-- <b-row
        v-if="canSeeWaitingList && inWaiting.length > 0"
        no-gutters
        class="d-flex align-items-center  flex-row justify-content-between">
        <div class="waiting-title">
          {{ $t('MEETING.WAITING_ROOM').toUpperCase() }}
        </div>
        <b-col
          class="line"
          style="margin-left: 8px; margin-right: 8px"
        />
        <div
          class="admit-all"
          @click="admitAll()">
          {{ $t('MEETING.WAITING_ADMITALL') }}
        </div>
      </b-row> -->
      <!-- <ul
        v-if="canSeeWaitingList && inWaiting.length > 0"
        class="list-unstyled">
        <li
          v-for="(person, index) in inWaiting"
          :key="index"
          class="d-flex align-items-center  flex-row justify-content-between">
          <div class="d-flex">
            <img
              v-if="person.presence && person.presence.avatar && person.presence.avatar != 'null'"
              :src="person.presence.avatar"
              class="img d-flex">
            <name-dot
              v-else
              :first-name="person.firstName"
              :last-name="person.lastName"/>
            <div class="d-flex flex-column name">
              {{ person.firstName }} {{ person.lastName }}
            </div>
          </div>
          <div>
            <check-icon
              :title="$t('MEETING.WAITING_ADMIT')"
              class="admit"
              @click="$parent.$parent.admitFromWatingRoom(person.id)"
            />
            <close-icon
              :title="$t('MEETING.WAITING_DENY')"
              class="deny"
              @click="$parent.$parent.denyFromWatingRoom(person.id)"/>
          </div>
        </li>
      </ul> -->
      <!-- <div
        v-if="canSeeWaitingList && inWaiting.length > 0"
        class="line d-flex align-items-center  flex-row justify-content-between"/>
      <b-row
        v-if="$parent.$parent.meetingInfo.webinar"
        no-gutters
        class="d-flex align-items-center  flex-row justify-content-between">
        <div class="waiting-title">
          {{ $t('MEETING.WEBINAR_SPEAKERS').toUpperCase() }}
        </div>
        <b-col
          class="line"
          style="margin-left: 8px; margin-right: 8px"
        />
      </b-row> -->
      <ul class="list-unstyled">
        <li
          v-for="(person, index) in inMeeting"
          :key="index"
          class="participant d-flex align-items-center flex-row justify-content-between">
          <div class="d-flex">
            <img
              v-if="person.avatarUrl && person.avatarUrl != 'null'"
              :src="person.avatarUrl"
              class="img d-flex">
            <name-dot
              v-else
              :first-name="person.firstName"
              :last-name="person.lastName"/>
            <div class="d-flex flex-column name">
              {{ person.firstName }} {{ person.lastName }}
              <small
                v-if="isModerator(person.id)"
                class="d-flex">{{ $t('MEETING.MODERATOR') }}</small>
              <small
                v-else-if="person.isWebrtc || (person.presenc && person.presence.isWebrtc)"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_WEB') }}</small>
              <small
                v-else-if="person.presence && person.presence.isPhone"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_PHONE') }}</small>
            </div>
          </div>
          <div
          style="display:inline-flex">
            <microphone-off-icon
              v-if="person.isMuted"
              class="muted"/>
            <b-btn
              v-if="person.id != -1 && !person.me"
              :id="`popover-participant-${person.id}-${person.jid}`"
              href="#"
              tabindex="0"
              variant="link"
              style="padding:0px">
              <dots-horizontal
                :size="32"
                :tabindex="person.id+'dots'"
                fill-color="#F8F8F8"
                class="dots"/>
            </b-btn>
            <b-popover
              v-if="person.id != -1 && !person.me"
              :target="`popover-participant-${person.id}-${person.jid}`"
              triggers="focus"
              placement="bottom">
              <ul class="list-unstyled setting-list">
                <li
                  :tabindex="person.id+'chat'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="privateChat(person)">
                  <message-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.CHAT_START_PRIVATE_CHAT') }}
                </li>
                <li
                  v-if="amImoderator && !isModerator(person.id)"
                  :tabindex="person.id+'makemoderator'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="makeModerator(person.id)">
                  <moderator-make-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.MAKE_MODERATOR') }}
                </li>
                <!-- <li
                  v-if="$parent.$parent.meetingInfo.webinar && (amImoderator || $parent.$parent.metaUserInfo.id == person.id)"
                  :tabindex="person.id+'movetoaudience'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="moveToAudience(person.id)">
                  <become-speaker-icon
                    :rotate="180"
                    class="mr-2"/>
                  {{ $t('MEETING.RETURN_AUDIENCE') }}
                </li> -->
                <!-- <li
                  v-if="/*!$parent.$parent.meetingInfo.webinar &&*/ amImoderator"
                  :class="{ disabled: person.isMuted }"
                  :tabindex="person.id+'muteaudio'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="muteUserAudio(person.id)">
                  <microphone-off-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.BLOCK_AUDIO') }}
                </li> -->
                <!-- <li
                  v-if="/*!$parent.$parent.meetingInfo.webinar &&*/ amImoderator"
                  :class="{ disabled: person.videoOff }"
                  :tabindex="person.id+'mutevideo'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="muteUserVideo(person.id)">
                  <video-off-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.BLOCK_VIDEO') }}
                </li> -->
                <!-- <li
                  v-if="canSeeWaitingList"
                  :class="{ disabled: isModerator(person.id) || canBypassWaiting(person) }"
                  :tabindex="person.id+'moveToWait'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="moveToWait(person.id)">
                  <waiting-room-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.SEND_TO_WAITING') }}
                </li> -->
                <li
                  v-if="amImoderator"
                  :tabindex="person.id+'kickOff'"
                  class="d-flex position-relative"
                  style="height:32px; line-height: 32px; vertical-align: middle;"
                  @click="kickOff(person.id)">
                  <kick-meeting-icon
                    :size="20"
                    class="mr-2"/>
                  {{ $t('MEETING.REMOVE_FROM_MEETING') }}
                  <!-- {{ $parent.$parent.meetingInfo.webinar ? $t('MEETING.REMOVE_FROM_WEBINAR') : $t('MEETING.REMOVE_FROM_MEETING') }} -->
                </li>
              </ul>
            </b-popover>
          </div>
        </li>
      </ul>
      <!-- <b-row
        v-if="$parent.$parent.meetingInfo.webinar"
        no-gutters
        class="d-flex align-items-center  flex-row justify-content-between">
        <div class="waiting-title">
          {{ $t('MEETING.WEBINAR_MODERATORS').toUpperCase() }}
        </div>
        <b-col
          class="line"
          style="margin-left: 8px; margin-right: 8px"
        />
      </b-row> -->
      <!-- <ul class="list-unstyled">
        <li
          v-for="(person, index) in areModerators"
          :key="index"
          class="participant d-flex align-items-center  flex-row justify-content-between">
          <div class="d-flex">
            <img
              v-if="person.presence && person.presence.avatar && person.presence.avatar != 'null'"
              :src="person.presence.avatar"
              class="img d-flex">
            <name-dot
              v-else
              :first-name="person.firstName"
              :last-name="person.lastName"/>
            <div class="d-flex flex-column name">
              {{ person.firstName }} {{ person.lastName }}
              <small
                v-if="isModerator(person.id)"
                class="d-flex">{{ $t('MEETING.MODERATOR') }}</small>
              <small
                v-else-if="person.isWebrtc || (person.presenc && person.presence.isWebrtc)"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_WEB') }}</small>
              <small
                v-else-if="person.presence && person.presence.isPhone"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_PHONE') }}</small>
            </div>
          </div>
          <div
            style="display:inline-flex">
            <microphone-off-icon
              v-if="person.isMuted"
              class="muted"/>
            <dots-horizontal
              v-if="canSeeMenu"
              :id="'popover-participant-moderator' + person.id"
              :size="32"
              :tabindex="person.id"
              fill-color="#F8F8F8"
              class="dots"/>
          </div>
          <b-popover
            v-if="canSeeMenu"
            :target="'popover-participant-moderator' + person.id"
            triggers="click"
            placement="bottom">
            <ul class="list-unstyled setting-list">
              <li
                v-if="true /*person.id != $parent.$parent.metaUserInfo.id*/"
                :tabindex="person.id+'movetospeaker'"
                class="d-flex position-relative"
                style="height:32px; line-height: 32px; vertical-align: middle;"
                @click="person.rh.substring(0,1) == '2' ? moveToAudience(person.id) : moveToSpeakers(person.id, person.rh.substring(0,1) == '1')">
                <become-speaker-icon
                  :rotate="person.rh.substring(0,1) == '2' ? 180 : 0"
                  class="mr-2"/>
                {{ person.rh.substring(0,1) == '2' ? $t('MEETING.RETURN_AUDIENCE') : $t('MEETING.MAKE_SPEAKER') }}
              </li>
              <li
                v-else
                :tabindex="person.id+'becomespeaker'"
                class="d-flex position-relative"
                style="height:32px; line-height: 32px; vertical-align: middle;"
                @click="person.rh.substring(0,1) == '2' ? becomeAudience() : becomeSpeaker()">
                <become-speaker-icon
                  :rotate="person.rh.substring(0,1) == '2' ? 180 : 0"
                  class="mr-2"/>
                {{ person.rh.substring(0,1) == '2' ? $t('MEETING.RETURN_AUDIENCE') : $t('MEETING.BECOME_SPEAKER') }}
              </li>
              <li
                v-if="true /*person.id != $parent.$parent.metaUserInfo.id*/"
                :tabindex="person.id+'kickOff'"
                class="d-flex position-relative"
                style="height:32px; line-height: 32px; vertical-align: middle;"
                @click="kickOff(person.id)">
                <kick-meeting-icon
                  :size="20"
                  class="mr-2"/>
                {{ $t('MEETING.REMOVE_FROM_WEBINAR') }}
              </li>
            </ul>
          </b-popover>
        </li>
      </ul> -->
      <!-- <b-row
        v-if="$parent.$parent.meetingInfo.webinar"
        no-gutters
        class="d-flex align-items-center  flex-row justify-content-between">
        <div class="waiting-title">
          {{ $t('MEETING.WEBINAR_AUDIENCE').toUpperCase() }}
        </div>
        <b-col
          class="line"
          style="margin-left: 8px; margin-right: 8px"
        />
      </b-row> -->
      <!-- <ul class="list-unstyled">
        <li
          v-for="(person, index) in areAudience"
          :key="index"
          class="participant d-flex align-items-center  flex-row justify-content-between">
          <div class="d-flex">
            <img
              v-if="person.presence && person.presence.avatar && person.presence.avatar != 'null'"
              :src="person.presence.avatar"
              class="img d-flex">
            <name-dot
              v-else
              :first-name="person.firstName"
              :last-name="person.lastName"/>
            <div class="d-flex flex-column name">
              {{ person.firstName }} {{ person.lastName }}
              <small
                v-if="isModerator(person.id)"
                class="d-flex">{{ $t('MEETING.MODERATOR') }}</small>
              <small
                v-else-if="person.isWebrtc || (person.presenc && person.presence.isWebrtc)"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_WEB') }}</small>
              <small
                v-else-if="person.presence && person.presence.isPhone"
                class="d-flex">{{ $t('MEETING.PARTICIPANTS_VIA_PHONE') }}</small>
            </div>
          </div>
          <div
            style="display:inline-flex">
            <raise-hand
              v-if="person.rh.substring(0,1) == '1'"
              @click="moveToAudience(person.id)"
            />
            <dots-horizontal
              v-if="canSeeMenu && true /*person.id != $parent.$parent.metaUserInfo.id*/"
              :id="'popover-participant-audience' + person.id"
              :size="32"
              :tabindex="person.id"
              fill-color="#F8F8F8"
              class="dots"/>
          </div>
        </li>
        <li
          v-if="($parent.$parent.meetingInfo.webinar && !amImoderator && $parent.$parent.meetingInfo.options && !$parent.$parent.meetingInfo.options.includes('[audience=1]'))"
          class="audience-hidden">
          {{ $t('MEETING.WEBINAR_HIDDEN_AUDIENCE') }}
        </li>
      </ul> -->
    </perfect-scrollbar>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'
import MicrophoneOffIcon from "icons/MicrophoneOff"
import DotsHorizontal from "icons/DotsHorizontal"
import CloseIcon from "icons/Close"
import VideoOffIcon from "icons/VideoOff"
import MakeModeratorIcon from "../icons/ModeratorMake"
import MessageIcon from "icons/Message"
import WaitingRoomIcon from "../icons/WaitingRoom"
import KickMeetingIcon from "../icons/KickMeeting"
import ModeratorMakeIcon from "../icons/ModeratorMake"
import BecomeSpeakerIcon from "../icons/BecomeSpeaker"
import RaiseHand from "../icons/RaiseHand"
import {computed, onMounted, ref, onBeforeUnmount} from "@vue/composition-api"
import NameDot from "./NameDot"
import CheckIcon from "icons/Check"
import {getWaitingOptions, parseJwt} from "../functions/globalMethods"
import {getJitsiToken} from "../functions/storageManager"

export default {
  name: 'ParticipantsJitsi',
  components: {
    NameDot,
    PerfectScrollbar,
    MicrophoneOffIcon,
    DotsHorizontal,
    CheckIcon,
    VideoOffIcon,
    CloseIcon,
    MakeModeratorIcon,
    MessageIcon,
    WaitingRoomIcon,
    KickMeetingIcon,
    ModeratorMakeIcon,
    BecomeSpeakerIcon,
    RaiseHand
  },
  setup(props, context) {
    const updateTimer = ref({});
    const myUser = ref({});

    const participantList = computed(() => {
      return participants.value.sort((a, b) => a.firstName ? a.firstName.localeCompare(b.firstName) : 1)
    })
    const participants = ref([])
    const inWaiting = computed(() => {
      return [];
      // return participantList.value.filter(i => i.isWaiting)
    })
    const inMeeting = computed(() => {
      return participantList.value;
      // if (context.parent.$parent.meetingInfo.webinar) {
      //   return participantList.value.filter(i => { return i.rh && i.rh.substring(0,1) == "2" })
      // }
      // else
      //   return participantList.value.filter(i => !i.isWaiting)
    })
    const areAudience = computed(() => {
      // if (context.parent.$parent.meetingInfo.webinar) {
      //   if (amImoderator.value || context.parent.$parent.meetingInfo.options.includes("[audience=1]"))
      //     return participantList.value.filter(i => { return ( (i.presence && !i.presence.isModerator) && (i.rh && i.rh.substring(0,1) == "1")) }).concat(participantList.value.filter(i => { return (i.presence && !i.presence.isModerator) && ((i.rh === "")) }))
      //   else
      //     return participantList.value.filter(i => { return ( (i.presence && !i.presence.isModerator && context.parent.$parent.metaUserInfo && i.id == context.parent.$parent.metaUserInfo.id) )})
      // }
      return []
    })
    const areModerators = computed(() => {
      // console.warn('areModerators', participantList.value);
        return participantList.value.filter(i => { return i.role && i.role === 'moderator' });
      // if (context.parent.$parent.meetingInfo.webinar) {
      //   return participantList.value.filter(i => { return i.presence && i.presence.isModerator })
      // }
      // return []
    })
    const canSeeWaitingList = computed(() => {
      return false
    //   if (!context.parent.$parent.meetingInfo.waitingRoom)
    //     return false
    //   if (context.parent.$parent.metaUserInfo) {
    //     let index = participantList.value.findIndex(part => part.id == context.parent.$parent.metaUserInfo.id)
    //     if (index >=0 && participantList.value[index].presence && participantList.value[index].presence.isModerator)
    //       return true
    //   }
    //   if (context.parent.$parent.meetingInfo) {
    //     if (context.parent.$parent.meetingInfo.options) {
    //       let waitingValue = context.parent.$parent.meetingInfo.options.substring(context.parent.$parent.meetingInfo.options.indexOf("[waitRoom=") + 10, context.parent.$parent.meetingInfo.options.indexOf("[waitRoom=") + 11)
    //       if (context.parent.$parent.meta_token && getWaitingOptions(2, waitingValue) == false) {
    //         //community member can admit/deny user, before check if login as quest by meta_token
    //         if (context.parent.$parent.metaSubscribedCommunities &&
    //           context.parent.$parent.metaSubscribedCommunities.communities.findIndex( value => value.id == (context.parent.$parent.meetingInfo.communityID)) >= 0)
    //           return true
    //       }
    //     }
    //     return false
    //   }
    //   else
    })
    const amImoderator = computed(() => {
      let index = participantList.value.findIndex(part => part.id === -1 || part.me);
      return index >=0 && participantList.value[index].role === 'moderator';
      // if (context.parent.$parent.metaUserInfo) {
      //   let index = participantList.value.findIndex(part => part.id == context.parent.$parent.metaUserInfo.id)
      //   return (index >=0 && participantList.value[index].presence) ?  participantList.value[index].presence.isModerator : false
      // } else {
      //   return false
      // }
    })
    const amIspeaker = computed(() => {
      return false;
      // if (context.parent.$parent.metaUserInfo) {
      //   let index = inMeeting.value.findIndex(part => part.id == context.parent.$parent.metaUserInfo.id)
      //   return index>=0
      // } else {
      //   return false
      // }
    })
    const canSeeMenu = computed(() => {
      return amImoderator.value //|| canSeeWaitingList.value
    })
    let ids = []
    function toggleTab() {
      context.parent.$parent.expanded = !context.parent.$parent.expanded
      context.parent.participant = !context.parent.participant
    }

    onMounted(() => {
      setTimeout(() => {
        roomParticipants(room => {
          if (room) {
            room.participants.forEach(i => {
              var user = parseParticipant(i);
              participants.value.push(user);
              ids.push(user.id);
            })
          }

          // add me to the participants list
          let me = parseMyself(getJitsiToken());
          if (me.id && ids.includes(me.id)) {
            updateParticipant(me); // to set 'me = true;'
          } else {
            addMyself(me);
          }
          myUser.value = me;
          // console.log('allParticipants', participants);

          context.parent.$parent.numberOfPeople = participantList.value.length;

          context.root.api.addEventListener('participantJoined', (e) => {
            // console.warn('participantJoined', e);
            if (!ids.includes(e.id)) {
              ids.push(e.id);
              var vol = context.parent.$parent.$refs.meetingControls.speaker ? 1 : 0;
              context.root.api.executeCommand('setParticipantVolume', e.id, vol);
              roomParticipants(room => {
                if (room) {
                  let part = room.participants.find(p => p.id === e.id);
                  if (part) {
                    participants.value.push(parseParticipant(part));
                    context.parent.$parent.numberOfPeople = participantList.value.length;
                  }
                }
              });
            }
          });

          context.root.api.addEventListener('participantLeft', (e) => {
            // console.warn('participantLeft', e);
            let user = participants.value.find(user => user.id === e.id)
            if (user) {
              const index = participants.value.indexOf(user)
              participants.value.splice(index, 1)
              ids.splice(ids.indexOf(e.id), 1)
              context.parent.$parent.numberOfPeople = participantList.value.length;
              // if (participants.value.length < 11)
              //   playSound("LEAVING.wav")
            }
          });

          context.root.api.addEventListener('displayNameChange', (e) => {
            // console.warn('displayNameChanged', e);
            updateParticipant(parseParticipant({ id: e.id, displayName: e.displayname }));
          });

          context.root.api.addEventListener('participantKickedOut', (e) => {
            // console.warn('participantKickedOut', e);
            if (e.kicked && e.kicked.id && e.kicked.id === myUser.value.id) {
              setTimeout(() => {
                context.parent.$parent.$refs.meetingControls.exitMeeting(true);
              }, 5000);
            }
          });

          context.root.api.addEventListener('participantRoleChanged', (e) => {
            // console.warn('participantRoleChanged', e);
            updateRole(e);
          });

        });

        // start refresh timer
        updateTimer.value = setInterval(() => {
          updateList();
        }, 5000);
      }, 1000);
    })

    onBeforeUnmount(() => {
      clearInterval(updateTimer.value);
    })

    function roomParticipants(func) {
      context.root.api.getRoomsInfo().then(rooms => {
        // console.warn('roomsInfo', rooms);
        var mainRoom = rooms.rooms.filter(i => { return i.isMainRoom});
        // console.warn('mainRoom', mainRoom);
        if (mainRoom && mainRoom.length > 0) {
          func(mainRoom[0]);
        } else {
          func(null);
        }
      })
    }

    function updateList() {
      roomParticipants(room => {
          if (room) {
            room.participants.forEach(i => {
              var user = parseParticipant(i);
              updateParticipant(user);
            })
          }
        });
    }

    function parseParticipant(part) {
      var i = part.displayName.indexOf(' ');
      if (i === -1) {
        i = part.displayName.length;
      }

      var user = {id: part.id};

      if (!!part.displayName) {
        user.firstName = part.displayName.substring(0, i);
        user.lastName = part.displayName.substring(i+1);
      }
      if (!!part.me) user.me = part.me;
      if (!!part.jid) user.jid = part.jid;
      if (!!part.role) user.role = part.role;
      if (!!part.avatarUrl) user.avatarUrl = part.avatarUrl;

      return user;
    }

    function updateParticipant(part) {
      // console.warn('updateParticipant', part);
      if (ids.includes(part.id)) {
        let user = participants.value.find(user => user.id === part.id);
        if (user) {
          !!part.firstName ? user.firstName = part.firstName : user.firstName = '';
          !!part.lastName ? user.lastName = part.lastName : user.lastName = '';
          !!part.avatarUrl ? user.avatarUrl = part.avatarUrl : user.avatarUrl = null;
          if (!!part.role) user.role = part.role;
          if (!!part.me) user.me = part.me;
        }
      }
    }

    function updateRole(obj) {
      if (ids.includes(obj.id)) {
        let user = participants.value.find(user => user.id === obj.id);
        if (user && obj.role && obj.role !== 'none') {
          user.role = obj.role;
        }
      }
    }

    function parseMyself(jwtToken) {
      let av = getMyIdAndAvatarLink();
      let token = parseJwt(jwtToken);
      let myself = {
        me: true,
        id: av ? av[0].participantId : -1,
        displayName: token.context.user.name,
        avatarUrl: av ? av[0].avatarURL : null
      }
      if (token.aud === 'jitsi' && token.iss === 'chat') {
        // jaas is little bit different
        myself.role = token.context.user.moderator == 'true' ? 'moderator' : 'participant'
      } else {
        myself.role = token.moderator == 'true' ? 'moderator' : 'participant'
      }

      return myself;
    }

    function addMyself(myself) {
      var user = parseParticipant(myself);
      participants.value.push(user);
      ids.push(user.id);
    }

    function getMyIdAndAvatarLink() {
      let users = context.root.api.getParticipantsInfo();
      let me = users.filter(user => user.formattedDisplayName && user.formattedDisplayName.endsWith('(me)') && user.email);
      return me;
    }

    function processPresense(message){
      console.log('participants', participants, message);
      //const regex = /\[([^\]]+)]/g
      if(message.meetingID !== -1 && message.status != 'BYE'){
        if(!ids.includes(message.user.id) && message.user.firstName !== ''){
          message.user.isMuted = !message.isPhone
          message.user.videoOff = true
          parseExtra(message, message.user)
          /*message.extra.match(regex).forEach(function(match){
            message.user[keyPairs[0]] = keyPairs[1] != 0 || keyPairs[1] == true // extra info for the user
          })*/
          message.user.presence = message
          participants.value.push(message.user)
          context.parent.$parent.numberOfPeople = participants.value.length
          ids.push(message.user.id)
          if (participants.value.length < 11)
            playSound("ENTERING.wav")
          if (message.user.id === context.parent.$parent.metaUserInfo.id) {
            message.user.isSelf = true
            message.user.isMuted = !context.parent.$parent.$refs.meetingControls.mic
            message.user.videoOff = !context.parent.$parent.$refs.meetingControls.camera
          }
        } else {
          let user = participants.value.find(user => user.id === message.user.id)
          if(user) {
            user.presence = message
            parseExtra(message, user)
            /*message.extra.match(regex).forEach(function(match){
              let keyPairs = match.slice(1,-1).split('=')
              user[keyPairs[0]] = keyPairs[1] != 0 || keyPairs[1] == true  // extra info for the user
            })*/
            const index = participants.value.indexOf(user)
            participants.value.splice(index, 1, user)
          }
        }
      } else {
        if(ids.includes(message.user.id)){
          let user = participants.value.find(user => user.id === message.user.id)
          if(user) {
            const index = participants.value.indexOf(user)
            participants.value.splice(index, 1)
            ids.splice(ids.indexOf(message.user.id), 1)
            if (participants.value.length < 11)
              playSound("LEAVING.wav")
          }
        }
      }
      if (context.parent.$parent.meetingInfo && context.parent.$parent.meetingInfo.moderators && context.parent.$parent.metaUserInfo) {
        if (context.parent.$parent.meetingInfo.moderators.includes(context.parent.$parent.metaUserInfo.id))
          context.parent.$parent.numberOfPeople = participants.value.length
        else
          context.parent.$parent.numberOfPeople = participants.value.filter(i => !i.isWaiting).length
      } else {
          context.parent.$parent.numberOfPeople = participants.value.length
      }
    }

    function parseExtra(message, user) {
      const regex = /\[([^\]]+)]/g
      let hasRh = false
      user.presence = message
      message.extra.match(regex).forEach(function(match){
        let keyPairs = match.slice(1,-1).split('=')
        if ( keyPairs[0] != 'rh')
          user[keyPairs[0]] = keyPairs[1] != 0 || keyPairs[1] == true  // extra info for the user
        else {
          hasRh = true
          user[keyPairs[0]] = keyPairs[1]
        }
      })
      if (hasRh == false)
        user['rh'] = ""
    }

    function processParticipant(message) {
      if (message.roomID != -1) {
        if(!ids.includes(message.user.id) && message.user.firstName !== ''){
          console.log("Participant update come sooner then presence update. Add participant: " + message.user.id)
          message.user.wsParticipant = message
          if (message.user.id === context.parent.$parent.metaUserInfo.id) {
            message.user.isSelf = true
            message.user.isMuted = !context.parent.$parent.$refs.meetingControls.mic
            message.user.videoOff = !context.parent.$parent.$refs.meetingControls.camera
          }
          if (!message.user.isSelf) {  // Only Control others with websocket messages
            message.user.isMuted = !message.isAudioOn
            message.user.videoOff = !message.isVideoOn
          }
          participants.value.push(message.user)
          context.parent.$parent.numberOfPeople = participants.value.length
          ids.push(message.user.id)
          if (participants.value.length < 11)
            playSound("ENTERING.wav")
        } else {
          let user = participants.value.find(user => user.id === message.user.id)
          if (user) {
            const index = participants.value.indexOf(user)
            if (!user.isSelf) { // Only Control others with websocket messages and for phone always set isMuted false
              if (user.presence && user.presence.isPhone) {
                user.isMuted = false
              } else {
                user.isMuted = !message.isAudioOn
              }
              user.videoOff = !message.isVideoOn
            }
            user.wsParticipant = message
            participants.value.splice(index, 1, user)  // this is literally a vue caveat
          }
        }
      }
      else {
        if(ids.includes(message.user.id)){
          let user = participants.value.find(user => user.id === message.user.id)
          if(user) {
            const index = participants.value.indexOf(user)
            participants.value.splice(index, 1)
            ids.splice(ids.indexOf(message.user.id), 1)
            if (participants.value.length < 11)
              playSound("LEAVING.wav")
          }
        }
      }
    }

    function playSound(sound) {
      if (context.parent.$parent.getItem('soundNotify') !== undefined && context.parent.$parent.getItem('soundNotify')) {
        let snd = new Audio("static/sounds/" + sound)
        snd.play()
      }
    }

    function isModerator(id) {
      let index = participantList.value.findIndex(part => part.id == id)
      if (index >=0 && participantList.value[index].role === 'moderator') {
        return true
      } else {
        return false
      }
      // let index = participantList.value.findIndex(part => part.id == id)
      // if (index >=0 && participantList.value[index].presence && participantList.value[index].presence.isModerator) {
      //   return true
      // } else if (context.parent.$parent.meetingInfo.owner == id) {
      //   return true
      // } else {
      //   return false
      // }
    }

    function privateChat(person) {
      if (context.parent.$parent.$refs.sideBar) {
        context.parent.$parent.$refs.sideBar.toggleBar('chat');
        if (context.parent.$refs.sideChat) {
          context.parent.$refs.sideChat.startPrivateChat(person);
        }
      }
    }

    function kickOff(id) {
      console.log("KICK OFF user id: " + id)
      context.root.api.executeCommand('kickParticipant', id);
      // context.parent.$parent.webrtcMeta.send(JSON.stringify({
      //   d_type: "WSKickUser",
      //   kickUserID: id,
      // }))
    }

    function makeModerator(id) {
      console.log("make moderator user id: " + id)
      context.root.api.executeCommand('grantModerator', id);
      // context.parent.$parent.makeModerator(id)
    }

    function muteUserAudio(id) {
      console.log("mute audio user id: " + id)
      context.parent.$parent.blockUserMedia(id, true, false)
    }

    function muteUserVideo(id) {
      console.log("mute video user id: " + id)
      context.parent.$parent.blockUserMedia(id, false, true)
    }

    function moveToWait(id) {
      console.log("move to waiting user id: " + id)
      context.parent.$parent.webrtcMeta.send(JSON.stringify({
        d_type: "WSWaiting",
        userID: id,
        waiting: true,
        denied: false
      }))
    }

    function canBypassWaiting(participant) {
      if (context.parent.$parent.meetingInfo) {
        if (context.parent.$parent.meetingInfo.options) {
          let waitingValue = context.parent.$parent.meetingInfo.options.substring(context.parent.$parent.meetingInfo.options.indexOf("[waitRoom=") + 10, context.parent.$parent.meetingInfo.options.indexOf("[waitRoom=") + 11)
          if (getWaitingOptions(4, waitingValue)) {
            //community member can bypass waiting, before check if login as quest by meta_token.value
            if (participant.presence &&
              participant.presence.isCommMember) {
              return true
            }
          }
        }
      }
      return false
    }

    function admitAll() {
      inWaiting.value.forEach( person => context.parent.$parent.admitFromWatingRoom(person.id) )
    }

    function moveToSpeakers(id, raiseHand) {
      console.log("move to speakers user id: " + id)
      if (raiseHand) {
        context.parent.$parent.webrtcMeta.send(JSON.stringify({
          d_type: "WSWebinarRH",
          userID: id,
          granted: true
        }))
      } else {
        context.parent.$parent.webrtcMeta.send(JSON.stringify({
          d_type: "WSWebinarRH",
          userID: id,
          upgraded: true
        }))
      }
    }

    function moveToAudience(id){
      if (amImoderator.value) {
        console.log("return to audience user id: " + id)
        context.parent.$parent.webrtcMeta.send(JSON.stringify({
          d_type: "WSWebinarRH",
          userID: id,
          stop: true
        }))
      }
    }

    function becomeSpeaker() {
      console.log("become speaker")
      context.parent.$parent.webrtcMeta.send(JSON.stringify({
        d_type: "WSHand",
        raiseHand: true,
        pin: null,
        question: ""
      }))
    }

    function becomeAudience() {
      console.log("become audience")
      context.parent.$parent.webrtcMeta.send(JSON.stringify({
        d_type: "WSHand",
        raiseHand: false,
        pin: null,
        question: ""
      }))
    }

    return {
      processPresense,
      toggleTab,
      participants,
      processParticipant,
      participantList,
      inWaiting,
      inMeeting,
      areModerators,
      areAudience,
      canSeeWaitingList,
      canBypassWaiting,
      amIspeaker,
      amImoderator,
      isModerator,
      canSeeMenu,
      myUser,
      kickOff,
      privateChat,
      makeModerator,
      muteUserAudio,
      muteUserVideo,
      moveToWait,
      admitAll,
      moveToSpeakers,
      moveToAudience,
      becomeSpeaker,
      becomeAudience
    }

  }
}
</script>
<style scoped>
li{
  height: 48px;
}
.participantsContainer{
 margin: 24px;
}
li .img{
  border-radius: 100%;
  width: 32px;
  height: 32px;
  margin-right: 12px;
}
.name{
  font-weight: 600;
  font-size: 14px;
}
.name small{
  font-weight: normal;
  font-size: 11px;
  color: #BBBBBB;
}
.muted{
  color: #f15f55;
}
.participant .dots {
  display: none;
  width: 32px;
  height: 32px;
}
.participant .dots:focus{
  display: inline-flex;
}
.participant .dots:hover {
  background-color: #4A4A4A;
}
.participant:hover .dots {
  display: inline-flex;
  border-radius: 16px;
  cursor: pointer;
}
.waiting-title {
  font-weight: 600;
  font-size: 10px;
  color: #cecece;
  letter-spacing: 1px;
}
.admit{
  color: #65CA30;
  border: solid 1px #65CA30;
  border-radius: 4px;
  cursor: pointer;
}
.admit:hover{
  background-color: #65CA30;
  color:#282828;
}
.deny{
  color: #f15f55;
  border: solid 1px #f15f55;
  border-radius: 4px;
  cursor: pointer;
}
.deny:hover{
  background-color: #f15f55;
  color:#282828;
}
.line {
  border-top: 1px solid #4A4A4A
}
.admit-all {
  font-weight: 600;
  font-size: 12px;
  color: #2491FF;
  cursor: pointer;
}
.badge{
  font-weight: 700;
  height: 23px;
  margin-left: 11px;
  width: 23px;
  text-align: center;
  line-height: 16px;
}
.disabled {
    pointer-events:none;
    opacity:0.6;
}
.audience-hidden {
  display:inline-flex;
  font-weight: 400;
  font-size: 14px;
  color: #BBBBBB;
  margin-top: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticipantsJitsi.vue